/*
 * <anzu-aplus-sensor> feature slider controller.
 * Desktop: tappable pills switch feature "state" panels (grid-stacked, CSS slide).
 * Mobile (<=749px): pills are hidden — the slider becomes a swipeable carousel with
 * subtle prev/next arrows and a 3s autoplay that loops. Autoplay only runs on mobile
 * when motion is allowed and the card is on-screen, and pauses on any manual interaction.
 * Pure CSS transitions (no library dependency); no inline handlers.
 */
(function () {
  var DIST = 28;            // px slide distance
  var AUTOPLAY_MS = 3000;   // auto-advance interval (mobile)
  var SWIPE_MIN = 40;       // px horizontal travel to count as a swipe

  var mqMobile = window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false, addEventListener: null };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSensor(scope) {
    (scope || document).querySelectorAll('[data-aplus-sensor]').forEach(function (card) {
      if (card.dataset.aplusReady) return;
      card.dataset.aplusReady = '1';

      var stage = card.querySelector('.aplus-sensor__stage');
      var panels = Array.prototype.slice.call(card.querySelectorAll('.aplus-sensor__panel'));
      var tabs = Array.prototype.slice.call(card.querySelectorAll('.aplus-sensor__pill'));
      var prevBtn = card.querySelector('[data-sensor-prev]');
      var nextBtn = card.querySelector('[data-sensor-next]');
      if (panels.length < 2) return;

      var cur = panels.findIndex(function (p) { return p.classList.contains('is-active'); });
      if (cur < 0) cur = 0;
      var busy = false;
      var autoTimer = null;

      function autoplayOn() { return mqMobile.matches && !reduce; }
      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
      function startAuto() {
        stopAuto();
        if (!autoplayOn()) return;
        autoTimer = setInterval(function () { if (!document.hidden) next(); }, AUTOPLAY_MS);
      }
      function bumpAuto() { if (autoplayOn()) startAuto(); } // reset the timer after a manual move

      // Opt-in (data-sensor-pills="rotate"): cycle the row so the active pill sits in the
      // middle, matching the Surge frames. Flex `order` only — the DOM order stays put, so
      // tab sequence and screen-reader order still follow the authored block order.
      var rotatePills = card.getAttribute('data-sensor-pills') === 'rotate';
      var midSlot = Math.floor(tabs.length / 2);

      function setTabs(next) {
        tabs.forEach(function (t, i) {
          var a = i === next;
          t.classList.toggle('is-active', a);
          t.setAttribute('aria-selected', a ? 'true' : 'false');
          if (rotatePills) {
            t.style.order = (i - next + midSlot + tabs.length) % tabs.length;
          }
        });
      }

      // Only one panel is ever on screen, so hold the rest of the films paused. Their markup
      // carries `autoplay` for the no-JS case, which would otherwise leave every state
      // streaming and decoding out of sight.
      function syncMedia(active) {
        panels.forEach(function (p, i) {
          // A panel may hold both a desktop and a mobile variant, one of which is display:none
          // at any breakpoint. offsetParent is null for the hidden one, so it stays parked.
          var vids = p.querySelectorAll('video');
          for (var n = 0; n < vids.length; n++) {
            if (vids[n].offsetParent !== null) { playPause(vids[n], i === active); }
            else { playPause(vids[n], false); }
          }
        });
      }

      function playPause(v, on) {
        if (on) {
          var playing = v.play();
          if (playing && playing.catch) playing.catch(function () { /* autoplay refused */ });
        } else {
          try { v.pause(); v.currentTime = 0; } catch (e) { /* poster stands in */ }
        }
      }

      setTabs(cur);   // seed the rotation for the state Liquid marked active
      syncMedia(cur); // and park every off-screen film

      function show(target, dir) {
        var nextI = ((target % panels.length) + panels.length) % panels.length; // wrap
        if (nextI === cur || busy) return;
        if (typeof dir !== 'number') dir = nextI > cur ? 1 : -1;
        var outP = panels[cur], inP = panels[nextI];

        setTabs(nextI);
        syncMedia(nextI);
        inP.removeAttribute('aria-hidden');

        if (reduce) {
          outP.classList.remove('is-active');
          outP.setAttribute('aria-hidden', 'true');
          inP.classList.add('is-active');
          cur = nextI;
          return;
        }

        busy = true;
        // Place incoming panel off to the side with no transition, then release.
        inP.style.transition = 'none';
        inP.style.opacity = '0';
        inP.style.transform = 'translateX(' + (DIST * dir) + 'px)';
        inP.classList.add('is-active');
        void inP.offsetWidth;
        inP.style.transition = '';
        inP.style.opacity = '';
        inP.style.transform = '';
        // Slide outgoing panel out the opposite way.
        outP.style.transition = '';
        outP.style.opacity = '0';
        outP.style.transform = 'translateX(' + (-DIST * dir) + 'px)';

        var settled = false;
        function settle() {
          if (settled) return;
          settled = true;
          outP.removeEventListener('transitionend', settle);
          outP.classList.remove('is-active');
          outP.setAttribute('aria-hidden', 'true');
          outP.style.transition = 'none';
          outP.style.opacity = '';
          outP.style.transform = '';
          void outP.offsetWidth;
          outP.style.transition = '';
          busy = false;
        }
        outP.addEventListener('transitionend', settle);
        setTimeout(settle, 620);
        cur = nextI;
      }
      function next() { show(cur + 1, 1); }
      function prev() { show(cur - 1, -1); }

      // Pills (desktop primary nav).
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); stopAuto(); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            tabs[n].focus();
            show(n);
            stopAuto();
          }
        });
      });

      // Arrows (mobile primary nav; present in DOM, shown via CSS on mobile).
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); bumpAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); bumpAuto(); });

      // Touch swipe. Passive listeners + horizontal-dominant check so vertical scroll is untouched.
      var sx = 0, sy = 0, tracking = false;
      var swipeTarget = stage || card;
      swipeTarget.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        sx = t.clientX; sy = t.clientY; tracking = true;
        stopAuto();
      }, { passive: true });
      swipeTarget.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > SWIPE_MIN && Math.abs(dx) > Math.abs(dy) * 1.4) {
          if (dx < 0) next(); else prev();
        }
        bumpAuto();
      }, { passive: true });

      // Autoplay only while the card is on-screen.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) startAuto(); else stopAuto(); });
        }, { threshold: 0.25 });
        io.observe(card);
      } else {
        startAuto();
      }

      // Start/stop autoplay when crossing the mobile breakpoint.
      var onMq = function () { if (autoplayOn()) startAuto(); else stopAuto(); };
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMq);
      else if (mqMobile.addListener) mqMobile.addListener(onMq);
    });
  }

  if (document.readyState !== 'loading') initSensor(document);
  else document.addEventListener('DOMContentLoaded', function () { initSensor(document); });
  document.addEventListener('shopify:section:load', function (e) { initSensor(e.target); });
})();
